import { Api } from "../../Api";

interface ContactData {
  name: string;
  email: string;
  phone_number: string;
  query: string;
}

export const sendContactDataService = async (contactData: ContactData) => {
  let url = `/contact/createQuery`;
  const response = await Api.post(url, contactData);
  return response;
};
